import React, { useState, useRef, useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { getTranslate } from "react-localize-redux";
import { actions } from "react-redux-form";
import moment from "moment";
import axios from "axios";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import Select from "react-select";
import {
  userActions,
  settingActions,
  configActions,
  fileActions,
  documentActions,
  reportActions,
  msgActions,
} from "../../../../../../redux/actions";
import {
  initConfigReportsSearchFormState,
  initDashboardSearchFormState,
  initDocsSearchFormState,
  initExecReportsSearchFormState,
  initFilesSearchFormState,
  initHomeSearchFormState,
} from "../../../../../../utils/constants";
import {
  random,
  timeAgo,
  timeStampToISODateString,
} from "../../../../../../utils";
import "./SwitchUserButton.css";

function SwitchUserButton({
  user,
  isSubUser,
  dispatch,
  defaultSearchPeriod,
  location,
  availableUsers,
}) {
  const [selectedUser, setSelectedUser] = useState({});
  const [modal, setModal] = useState(false);
  const selectRef = useRef(null);

  useEffect(() => {
    if (modal) {
      setTimeout(() => {
        selectRef.current && selectRef.current.focus();
      }, 500);
    }
  }, [modal]);

  const handleSelectUser = (selUser) => {
    setSelectedUser(selUser);
  };

  const toggleModal = () => {
    setModal(!modal);
    setSelectedUser({});
  };

  const handleChangeUserClick = () => {
    if (!isSubUser) {
      if (window.isEditingMode) {
        dispatch(configActions.toggleModalConfirm(true));
        dispatch(configActions.setConfirmDialogHandler(null));
      } else {
        toggleModal();
      }
    } else {
      if (
        location.pathname.startsWith("/documents") &&
        location.pathname !== "/documents"
      ) {
        window.location.pathname = "/documents";
      }
      const defaultSize = user?.pageItemCount || 20;
      var _from = null,
        _to = null;
      if (!isNaN(defaultSearchPeriod) && defaultSearchPeriod > 0) {
        _from = moment
          .utc()
          .subtract(defaultSearchPeriod, "month")
          .add(1, "day")
          .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
          .toDate();
        _to = moment
          .utc()
          .set({ hour: 23, minute: 59, second: 59, millisecond: 999 })
          .toDate();
      }

      let gridsSettings = user?.gridsSettings || [];
      let filesSettings = gridsSettings.filter(
        (item) => item.gridId === "files"
      )[0];
      dispatch(
        fileActions.setHiddenColumn(
          (filesSettings && filesSettings.visibleColumns) || []
        )
      );
      let docsSettings = gridsSettings.filter(
        (item) => item.gridId === "documents"
      )[0];
      dispatch(
        documentActions.setHiddenColumn(
          (docsSettings && docsSettings.visibleColumns) || []
        )
      );
      dispatch(
        actions.change("fileSearch", {
          ...initFilesSearchFormState,
          Size: defaultSize,
          Start: _from,
          End: _to,
        })
      );
      dispatch(
        actions.change("docSearch", {
          ...initDocsSearchFormState,
          Size: defaultSize,
          Start: _from,
          End: _to,
        })
      );
      dispatch(
        actions.change("execReportSearch", {
          ...initExecReportsSearchFormState,
          Size: defaultSize,
          Start: _from,
          End: _to,
        })
      );
      dispatch(
        actions.change("configReportSearch", {
          ...initConfigReportsSearchFormState,
          Size: defaultSize,
        })
      );
      dispatch(documentActions.setDocumentListParams("Size", defaultSize));
      dispatch(
        actions.change("dashboardSearch", { ...initDashboardSearchFormState })
      );
      dispatch(fileActions.clearFiles());
      dispatch(documentActions.clearDocuments());
      dispatch(reportActions.clearReports());
      dispatch(userActions.switchToMain());
      dispatch(configActions.getReportsDescriptionsJson());
      dispatch(configActions.resetProjectsStores());
      dispatch(configActions.getActiveCustomers());
      dispatch(configActions.getPlatformNames());
      dispatch(settingActions.getAvailableUsers());
      dispatch(settingActions.getChannnelList());
      dispatch(settingActions.getSlaCalenderList());
      dispatch(settingActions.getPlatformsList());
      dispatch(configActions.getAllChannels({ ExternalView: false }));
    }
  };

  const handleSwitchUser = () => {
    const params = {
      UserName: encodeURIComponent(selectedUser?.value),
      Password: encodeURIComponent(random(10)),
      RememberMe: false,
    };
    axios.post("Account/SubLogin", params).then((response) => {
      var json = response.data;
      if (json.Errors && json.Errors.length) {
        dispatch(msgActions.error("Login to Subuser", json.Errors[0]));
        return;
      }
      const { Status, PortalUserSettings } = json.Data;
      if (Status === "OK") {
        var _from = null,
          _to = null;
        if (!isNaN(defaultSearchPeriod) && defaultSearchPeriod > 0) {
          _from = moment
            .utc()
            .subtract(defaultSearchPeriod, "month")
            .add(1, "day")
            .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
            .toDate();
          _to = moment
            .utc()
            .set({ hour: 23, minute: 59, second: 59, millisecond: 999 })
            .toDate();
        }
        var subUserToken = response.request.getResponseHeader("portaltoken");
        if (!!subUserToken) {
          const defaultSize = PortalUserSettings.pageItemCount || 20;
          // store to local storage
          let gridsSettings = PortalUserSettings.gridsSettings || [];
          let filesSettings = gridsSettings.filter(
            (item) => item.gridId === "files"
          )[0];
          dispatch(
            fileActions.setHiddenColumn(
              (filesSettings && filesSettings.visibleColumns) || []
            )
          );
          let docsSettings = gridsSettings.filter(
            (item) => item.gridId === "documents"
          )[0];
          dispatch(
            documentActions.setHiddenColumn(
              (docsSettings && docsSettings.visibleColumns) || []
            )
          );
          dispatch(
            actions.change("fileSearch", {
              ...initFilesSearchFormState,
              Size: defaultSize,
              Start: _from,
              End: _to,
            })
          );
          dispatch(
            actions.change("docSearch", {
              ...initDocsSearchFormState,
              Size: defaultSize,
              Start: _from,
              End: _to,
            })
          );
          dispatch(
            actions.change("execReportSearch", {
              ...initExecReportsSearchFormState,
              Size: defaultSize,
              Start: _from,
              End: _to,
            })
          );
          dispatch(
            actions.change("configReportSearch", {
              ...initConfigReportsSearchFormState,
              Size: defaultSize,
            })
          );
          dispatch(documentActions.setDocumentListParams("Size", defaultSize));
          dispatch(
            actions.change("dashboardSearch", {
              ...initDashboardSearchFormState,
            })
          );
          dispatch(
            actions.change("homeSearch", {
              ...initHomeSearchFormState,
            })
          );
          dispatch(
            userActions.switchToSubUser(PortalUserSettings, subUserToken)
          );
          if (!PortalUserSettings.senderId) {
            dispatch(
              configActions.setExternalUserData(
                PortalUserSettings.customerGlobalId
              )
            );
            localStorage.setItem("LastLocationHash", "#/home");
            window.location.hash = "#/home";
          } else {
            localStorage.setItem("LastLocationHash", "#/documents");
            window.location.hash = "#/documents";
          }
          dispatch(configActions.getReportsDescriptionsJson());
          dispatch(configActions.getAllChannels({ ExternalView: true }));
          toggleModal();
        } else {
          dispatch(msgActions.error("Login to Subuser", "Server failed"));
        }
      }
    });
  };

  const userOpts = (availableUsers || [])
    .sort((a, b) => (a.LastLoginDisplay > b.LastLoginDisplay ? 1 : -1))
    .map((user) => {
      var name = "";
      if (user?.UserId && user?.UserId.length > 0) name = user?.UserId;
      if (user?.CompanyName && user?.CompanyName.length > 0) {
        if (name === "") name = user?.CompanyName;
        else name += " - " + user?.CompanyName;
      }
      if (
        user?.LastLoginDisplay &&
        user?.LastLoginDisplay.toString().length > 0
      ) {
        var timeStamp =
          new Date().getTime() - parseInt(user?.LastLoginDisplay, 10);
        timeStamp = timeAgo(
          timeStampToISODateString(new Date(parseInt(timeStamp, 10)))
        );
        if (name === "") name = "(" + timeStamp + ")";
        else name += " - (" + timeStamp + ")";
      }
      return { value: user?.UserId, label: name };
    });

  return (
    <>
      <button
        className="nav-link default-top-bar-color w_action_top_menu nav-hearder-button"
        onClick={handleChangeUserClick}
        style={{ fontSize: "14pt" }}
      >
        <span className="fa fa-exchange-alt" aria-hidden="true" />
      </button>
      <Modal isOpen={modal} toggle={toggleModal}>
        <ModalHeader toggle={toggleModal}>Switch to user</ModalHeader>
        <ModalBody style={{ height: "150px" }}>
          <Select
            ref={selectRef}
            openOnFocus
            name="userId"
            className="user-select"
            value={selectedUser && selectedUser?.value}
            onChange={handleSelectUser}
            options={userOpts}
            placeholder="Type username or company name..."
          />
        </ModalBody>
        <ModalFooter className="text-center">
          <button
            type="button"
            className="btn btn-primary"
            onClick={handleSwitchUser}
          >
            Switch
          </button>
        </ModalFooter>
      </Modal>
    </>
  );
}

function mapStateToProps(state) {
  const {
    locale,
    authentication: { user, isSubUser },
    settings: { availableUsers },
  } = state;
  return {
    user,
    availableUsers,
    isSubUser,
    defaultSearchPeriod: state.config.defaultSearchPeriod,
    translate: getTranslate(locale),
  };
}

const connectedSwitchUserButton = connect(mapStateToProps)(
  withRouter(SwitchUserButton)
);
export { connectedSwitchUserButton as SwitchUserButton };
